import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';

export const apiServerGuard: CanActivateFn = () => {
  const router = inject(Router);
  const apiServer = sessionStorage.getItem('api_server');

  if (!apiServer) {
    return router.parseUrl('/login');
  }

  return true;
};